/**
 * Fluxo OAuth Rede Ads (conexão e tela de sucesso pós-login sem acesso à plataforma):
 * o query param `token` é um JWT de integração/convite (terceiros), não o accessToken de sessão do app.
 */
export const REDE_ADS_INTEGRATION_LINK_TOKEN_STORAGE_KEY = 'redeAdsIntegrationLinkToken';

const REDE_ADS_CONNECT_PATHS = [
    '/conect-google-ads-profile',
    '/conect-meta-ads-profile',
    '/conect-google-ads-profile-success',
    '/conect-meta-ads-profile-success',
] as const;

export function isRedeAdsConnectProfilePath(pathname: string): boolean {
    return REDE_ADS_CONNECT_PATHS.some((p) => pathname === p);
}
